
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface SubscriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  feature: string;
  reason: 'limit_reached' | 'not_available';
}

export function SubscriptionModal({ isOpen, onClose, feature, reason }: SubscriptionModalProps) {
  const messages = {
    limit_reached: `You have reached the maximum usage limit for ${feature} in your current plan.`,
    not_available: `This feature is not available in your current plan.`,
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Subscription Required</DialogTitle>
          <DialogDescription>
            {messages[reason]}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-2 justify-end">
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
